import ScheduleForm from "./ScheduleForm";

const ContactDetails = () => {
  return (
    <div className="w-full h-[93vh] overflow-scroll p-10 flex items-center justify-evenly">
      <div className="hidden md:flex md:w-[40%] p-5 h-full">
        <p className="text-7xl bg-gradient-to-r from-purple-400 via-violet-500 to-indigo-400 inline-block text-transparent bg-clip-text xl:text-[9rem] font-header font-medium leading-[8rem]">We're eager to see you</p>
      </div>
      <ScheduleForm />
    </div>
  )
}

export default ContactDetails;
